'use client'

import Script from 'next/script'
import { usePathname } from 'next/navigation'
import { rotaComGtm } from '@/lib/csp'

// Google Tag Manager só nas rotas públicas do funil (lista em PREFIXOS_GTM,
// lib/csp.ts). Até 14/09/2026 o container carregava no layout raiz, dentro do
// backoffice também: quem publica no GTM conseguiria rodar script na sessão
// de um master, e os caminhos internos iam parar no GA4. O nonce vem do
// middleware (CSP em bloqueio) — sem ele o script inline seria barrado.
export default function GtmPublico({ id, nonce }: { id: string | undefined; nonce: string | undefined }) {
  const pathname = usePathname()
  if (!id || !rotaComGtm(pathname)) return null
  return (
    <>
      <Script id="gtm-base" strategy="afterInteractive" nonce={nonce}>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');`}
      </Script>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${id}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
